<script lang="ts">
    import VpDeleteBinIcon from '@decathlon-experience/icons/svelte/VpDeleteBinIcon';

    import { trans } from '$assets/shop-translator.js';
    import Button from '$saga/components/Button.svelte';
    import NumberInput from '$saga/components/NumberInput.svelte';
    import PaxAgeRangeLabel from '$saga/views/shared/RoomPax/PaxAgeRangeLabel.svelte';
    import { ROOM_ADULT_HARD_MAX } from '$saga/views/Tour/Aside/form/SelectPaxStepForm/utils';
    import type { AgeRules } from '$saga/views/Tour/types';

    export let index: number;
    export let adultCount: number;
    export let childCount: number;
    export let showChildren: boolean;
    export let canIncrementAdults: boolean;
    export let canIncrementChildren: boolean;
    export let childrenMax: number | null | undefined;
    export let minAgeAllowed: number | null;
    export let maxAgeAllowed: number | null;
    export let ageRules: AgeRules;
    export let onAdultsIncrement: () => void;
    export let onAdultsDecrement: () => void;
    export let onAdultsInput: ((event: Event) => void) | undefined = undefined;
    export let onChildrenIncrement: () => void;
    export let onChildrenDecrement: () => void;
    export let onChildrenInput: ((event: Event) => void) | undefined =
        undefined;
    export let showDelete: boolean;
    export let onDelete: () => void;
</script>

<div
    class="flex flex-col gap-m rounded-lg border border-solid border-border-quiet p-s"
>
    <span class="font-semibold"
        >{trans('tour.accommodation.hotels.accommodation_type.room')}
        {index + 1}</span
    >

    <div class="flex items-center justify-between">
        <PaxAgeRangeLabel
            kind="adults"
            {minAgeAllowed}
            {maxAgeAllowed}
            {ageRules}
        />
        <NumberInput
            value={String(adultCount)}
            max={ROOM_ADULT_HARD_MAX}
            min={1}
            id="adults-room-{index}"
            onInput={onAdultsInput}
            minusBtnClasses={adultCount === 1 ? 'text-bord-quiet' : ''}
            minusBtnProps={{ disabled: adultCount === 1 }}
            onDecrement={onAdultsDecrement}
            plusBtnClasses={canIncrementAdults ? '' : 'text-bord-quiet'}
            plusBtnProps={{ disabled: !canIncrementAdults }}
            onIncrement={onAdultsIncrement}
        />
    </div>

    {#if showChildren}
        <div class="flex items-center justify-between">
            <PaxAgeRangeLabel
                kind="children"
                {minAgeAllowed}
                {maxAgeAllowed}
                {ageRules}
            />
            <NumberInput
                value={String(childCount)}
                max={childrenMax}
                min={0}
                id="children-room-{index}"
                onInput={onChildrenInput}
                minusBtnClasses={childCount === 0 ? 'text-bord-quiet' : ''}
                minusBtnProps={{ disabled: childCount === 0 }}
                onDecrement={onChildrenDecrement}
                plusBtnClasses={canIncrementChildren ? '' : 'text-bord-quiet'}
                plusBtnProps={{ disabled: !canIncrementChildren }}
                onIncrement={onChildrenIncrement}
            />
        </div>
    {/if}

    <slot />

    {#if showDelete}
        <div
            class="flex justify-end border-t border-solid border-border-quiet pt-m"
        >
            <Button
                type="button"
                size="small"
                intent="tertiary"
                class="text-content-quiet"
                on:click={onDelete}
                startIcon={VpDeleteBinIcon}
            >
                {trans('tour.aside_panel.travelgate.delete_room')}
            </Button>
        </div>
    {/if}
</div>
